// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9b33c8a6","239":"6f480734","453":"4e9848a6","455":"ddf31dfb"}[chunkId] + ".chunk.js";
};